<template>
  <NuxtLink
    v-if="to"
    :to="to"
    class="button"
    :class="`button--${props.variant} button--${props.size}`"
  >
    <slot></slot>
  </NuxtLink>
  <a
    v-else-if="href"
    :href="href"
    class="button"
    :class="`button--${props.variant} button--${props.size}`"
  >
    <slot></slot>
    <ClientOnly><FontAwesomeIcon icon="fa-arrow-up-right-from-square" /></ClientOnly>
  </a>
  <button
    v-else
    :type="props.type"
    class="button"
    :class="`button--${props.variant} button--${props.size}`"
  >
    <slot></slot>
  </button>
</template>
<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'button',
    validator: value => {
      return ['button', 'submit'].includes(value)
    },
  },
  variant: {
    type: String,
    validator: value => {
      return ['primary', 'secondary', 'tertiary'].includes(value)
    },
    default: 'primary'
  },
  size: {
    type: String,
    validator: value => {
      return ['md', 'lg'].includes(value)
    },
    default: 'md'
  },
  to: String,
  href: String,
})
</script>
<style scoped>
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: .2rem solid;
  min-height: var(--input-height);
  padding: .2rem var(--gap-sm);
  text-align: center;
  font-weight: bold;
  text-decoration: none;
}
.button--primary,
.button--secondary {
  text-transform: uppercase;
}
.button--primary,
.button--tertiary {
  color: #FFF;
}
.button--primary {
  background-color: var(--color-main-500);
}
.button--secondary {
  background-color: var(--color-main-50);
  color: var(--color-main-500);
}

.button--lg {
  height: 6rem;
  padding-inline: var(--gap);
  border-width: .4rem;
  font-size: 1.8rem;
}
</style>